<template>
  <v-dialog
    v-model="show"
    max-width="485"
  >
    <v-toolbar>
      <v-toolbar-title>
        <v-icon>mdi-folder-download</v-icon>
        <span>Baixar Processo</span>
      </v-toolbar-title>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-layout column class="my-3 px-3">
          <v-layout class="pa-2 folder-container" :style="{'border-color': colors.grey.lighten2}">
            <span class="folder-type-border" :style="{'border-left-color': colors.grey.lighten2}">&nbsp;</span>
            <v-icon color="amber" class="mr-3" medium>mdi-folder-open</v-icon>
            <v-layout column>
              <strong class="grey--text text--darken-2 folder-id">{{ folder.process_number }}</strong>
              <div>{{ folder.folder_type.name }}</div>
            </v-layout>
          </v-layout>
      </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout justify-center>
          <v-btn
            flat
            @click="toggleFolderDownloadDialog(false)"
            :disabled="loading"
          >
            Fechar
          </v-btn>
          <v-btn
            class="white--text"
            color="blue darken-1"
            @click="downloadFolder"
            :loading="loading"
            :disabled="loading"
          >
            Baixar
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import colors from 'vuetify/es5/util/colors';
import foldersService from '@/services/FoldersService';

export default {
  name: 'FolderDownloadDialog',
  data() {
    return {
      colors,
      loading: false,
    };
  },
  props: {
    show: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    toggleFolderDownloadDialog(bool) {
      this.$emit('toggleFolderDownloadDialog', bool);
    },
    downloadFolder() {
      this.loading = true;
      foldersService.downloadFolder({ id: this.folder.id })
        .then(({ data }) => {
          this.onDownloadFolderSuccess(data.url);
        })
        .catch((err) => {
          this.onDownloadFolderError(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onDownloadFolderError(err) {
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'error',
        message: `Erro ao reunir os documentos - ${err.message}`,
        button: { show: true, text: 'Fechar', message: '' },
        timeout: 6000,
        messageIcon: 'mdi-alert-outline',
      });
      this.toggleFolderDownloadDialog(false);
    },
    onDownloadFolderSuccess(url) {
      const a = document.createElement('a');
      a.href = url;
      a.setAttribute('download', url);
      a.click();
      this.toggleFolderDownloadDialog(false);
    },
  },
  computed: {
    folder() {
      return this.$store.getters.activeFolder;
    },
  },
};
</script>

<style scoped>
  .folder-container {
    border: 1px solid;
    border-radius: 3px;
    position: relative;
  }
  .folder-type-border {
    position: absolute;
    height: 100%;
    left: -1px;
    top: 0px;
    border-radius: 3px 0 0 3px;
    border-left: 5px solid;
    transition: ease-in-out .15s;
  }
</style>



// WEBPACK FOOTER //
// src/components/folder/show/toolbar/action/FolderDownloadDialog.vue